import { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useUser } from '@/hooks/use-user';

interface InternalGuardProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function InternalGuard({ children, fallback }: InternalGuardProps) {
  const user = useUser();
  const navigate = useNavigate();
  const { dealId } = useParams<{ dealId: string }>();
  const { search, hash } = useLocation();

  useEffect(() => {
    if (user && user.isInternalUser !== true && fallback === undefined) {
      if (dealId) {
        navigate(`/deal/${dealId}${search}${hash}`, { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    }
  }, [user, dealId, search, hash, navigate, fallback]);

  if (user?.isInternalUser !== true) {
    return user ? <>{fallback ?? null}</> : null;
  }

  return <>{children}</>;
}
